import { zeroWidthNonBreakingSpace } from '@upright/ui/common/generic/utilities/zero-width-space';
import { ModalInfoBoxWrap } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/modal-info-box-wrap';
import {
  commonInfoBoxBorder,
  commonOverlaySmallShadow,
} from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { Bounds, LensBoxMode, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ReactNode, CSSProperties, ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';

interface Props {
  side: Side;
  children: ReactNode;
  topColor?: string;
  refArea?: Bounds;
  // maxWidth?: number;
  setMoreWidthOnWiderThan1440?: boolean;
}

export const GenericDynamicHeightInfoBox = forwardRef(function _GenericDynamicHeightInfoBox(
  props: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const layout = useCarouselLayout();
  const boxesArea = props.refArea ? props.refArea : layout.boxesArea(props.side);

  if (layout.boxMode === LensBoxMode.MODAL) {
    return (
      <ModalInfoBoxWrap maxWidth={layout.boxesWidth}>
        <Main>
          {props.topColor ? (
            <ColorBlock style={{ backgroundColor: props.topColor }}>{zeroWidthNonBreakingSpace}</ColorBlock>
          ) : undefined}
          {props.children}
        </Main>
      </ModalInfoBoxWrap>
    );
  } else {
    const style: CSSProperties = {
      top: boxesArea.y1,
      height: boxesArea.height,
      left: boxesArea.x1,
      width: boxesArea.width,
    };
    return (
      <Root style={style} setMoreWidthOnWiderThan1440={props.setMoreWidthOnWiderThan1440}>
        <InfoBox ref={ref} {...props} />
      </Root>
    );
  }
});

const InfoBox = forwardRef(function _InfoBox(props: Props, ref: ForwardedRef<HTMLDivElement>) {
  return (
    <Main ref={ref}>
      {props.topColor ? (
        <ColorBlock style={{ backgroundColor: props.topColor }}>{zeroWidthNonBreakingSpace}</ColorBlock>
      ) : undefined}
      {props.children}
    </Main>
  );
});

const Root = styled.div<{ setMoreWidthOnWiderThan1440?: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  // RN: not the prettiest, but an easy way to increase the width of some cards in the impact tree for wider screens without creating a new component.
  @media screen and (min-width: 1440px) {
    width: ${props => props.setMoreWidthOnWiderThan1440 && '400px !important'};
  }
`;

const Main = styled.div`
  ${commonInfoBoxBorder};
  background-color: white;
  width: 100%;
  font-size: 12px;
  text-align: left;
  ${commonOverlaySmallShadow};
  z-index: 1;
`;

const ColorBlock = styled.div`
  height: 2px;
`;
